import { HttpClientModule } from '@angular/common/http';
import { makeStateKey, NgModule, TransferState } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { InMemoryCache } from '@apollo/client/core';
import { Apollo, ApolloModule } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '../../../environments/environment';

const STATE_KEY = makeStateKey<any>('apollo.state');

@NgModule({
  imports: [BrowserModule, HttpClientModule, ApolloModule],
})
export class GraphQLModule {
  cache: InMemoryCache;

  constructor(
    apollo: Apollo,
    httpLink: HttpLink,
    private readonly transferState: TransferState
  ) {
    this.cache = new InMemoryCache();
    const isBrowser = this.transferState.hasKey<any>(STATE_KEY);

    apollo.create({
      link: httpLink.create({ uri: `${environment.api}/graphql` }),
      cache: this.cache,
      ssrMode: true,
      defaultOptions: {
        query: {
          fetchPolicy: 'cache-first',
        },
      },
    });

    if (isBrowser) {
      this.onBrowser();
    } else {
      this.onServer();
    }
  }

  onBrowser(): void {
    const state = this.transferState.get<any>(STATE_KEY, null);
    this.cache.restore(state);
  }

  onServer(): void {
    this.transferState.onSerialize(STATE_KEY, () => {
      return this.cache.extract();
    });
  }
}
